import React from 'react';
import { Box, InputBase, IconButton, Button} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const ChatInput = ({ userInput, onInputChange, onSendMessage, sendDisabled, colors}) => {
  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        onSendMessage();
      }}
      sx={{ display: 'flex', padding: 1 }}
    >

      <InputBase
        sx={{ flexGrow: 1, paddingLeft: 1, paddingRight: 1 }}
        placeholder="Wpisz swoje pytanie..."
        value={userInput}
        onChange={(e) => onInputChange(e.target.value)}
      />

    { !sendDisabled && 
      <IconButton
        type="submit"
        sx={{ color: colors.primary.backgroundColor }}
        disabled={!userInput.trim()}
      >
        <SendIcon sx={{color:colors.secondary.backgroundColor}} />
      </IconButton>
    }
    </Box>
  );
};

export default ChatInput;